import { CancelablePromise, OpenAPI, request as __request } from '/src/api';
import { TAdvanceId } from '/src/lib/models';
import {
  TCreateAdvanceRequest,
  TCreateAdvanceResponse,
  TDeleteAdvanceResponse,
  TGetAdvanceResponse,
  TListAdvancesRequest,
  TListAdvancesResponse,
  TUpdateAdvanceRequest,
  TUpdateAdvanceResponse,
} from '/src/lib/types';

export class AdvanceService {
  /**
   * List Advances
   * @returns Advance[]
   * @throws ApiError
   */
  public static async query(req?: TListAdvancesRequest): CancelablePromise<TListAdvancesResponse> {
    const res = (await __request(OpenAPI, {
      method: 'GET',
      url: '/advances',
      query: req,
    })) as TListAdvancesResponse;

    return res;
  }

  /**
   * Get Advance
   * @param id TAdvanceId
   * @returns Advance
   * @throws ApiError
   */
  public static async get(id: TAdvanceId): CancelablePromise<TGetAdvanceResponse> {
    const res = (await __request(OpenAPI, {
      method: 'GET',
      url: '/advances/{id}',
      path: { id },
    })) as TGetAdvanceResponse;

    return res;
  }

  /**
   * Create Advance
   * @param advance Advance
   * @returns Advance
   * @throws ApiError
   */
  public static async create(req: TCreateAdvanceRequest): CancelablePromise<TCreateAdvanceResponse> {
    const res = (await __request(OpenAPI, {
      method: 'POST',
      url: '/advances',
      body: req,
    })) as TCreateAdvanceResponse;

    return res;
  }

  /**
   * Update Advance
   * @param advance Advance
   * @returns Advance
   * @throws ApiError
   */
  public static async update(id: TAdvanceId, req: TUpdateAdvanceRequest): CancelablePromise<TUpdateAdvanceResponse> {
    const res = (await __request(OpenAPI, {
      method: 'PUT',
      url: '/advances/{id}',
      path: { id },
      body: req,
    })) as TUpdateAdvanceResponse;

    return res;
  }

  /**
   * Delete Advance
   * @param id TAdvanceId
   * @returns Advance
   * @throws ApiError
   */
  public static async remove(id: TAdvanceId): CancelablePromise<TDeleteAdvanceResponse> {
    const res = (await __request(OpenAPI, {
      method: 'DELETE',
      url: '/advances/{id}',
      path: { id },
    })) as TDeleteAdvanceResponse;

    return res;
  }
}
